import React from 'react'
import { useJobsList } from './useJobsList'
import { ListItem } from './ListItem/ListItem'
import Button from '@mui/material/Button'

const component = 'jobs'
const loadComponent = 'load-more'

export function JobList() {
    const { increaseJobsNumber, jobsNumber, jobs, allShown } = useJobsList()

    return (
        <>
            <div className={component}>
                {jobs && jobs.length > 0 ? (
                    <ul className={`${component}__list`}>
                        {jobs.slice(0, jobsNumber).map((job) => (
                            <ListItem key={job.id} job={job} />
                        ))}
                    </ul>
                ) : (
                    <div className="d-flex flex-row flex-wrap">
                        <div className="flex-item flex-basis-100 md:flex-basis-25 lg:flex-basis-25 xl:flex-basis-25">
                            <span>There are currently no job openings for your selected criteria.</span>
                        </div>
                    </div>
                )}
            </div>
            {!allShown ? (
                <div className={loadComponent}>
                    <div className={`${loadComponent}__container`} onClick={increaseJobsNumber}>
                        <Button className={`${loadComponent}__container-title`} variant="contained">
                            See more
                        </Button>
                    </div>
                </div>
            ) : null}
        </>
    )
}
